import React from 'react'

function InvoiceEdit() {
  return (
    <div>InvoiceEdit</div>
  )
}

export default InvoiceEdit